// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_76bc0b","pagination__item":"_781440","pagination__item--active":"d1a0e3"};